import React from "react";
import "./DescriptionBox.css";

const DescriptionBox = () => {
  return (
    <div className="descriptionbox">
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descrptionbox-nav-box-fade">Reviews (188)</div>
      </div>
      <div className="descriptionbox-description">
        <p>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eaque
          ratione minus officia ut quibusdam vitae dolore dolorem! Possimus
          atque fugit incidunt quas quasi nam numquam, similique unde,
          asperiores eveniet voluptate pariatur a temporibus ab et dolorum quos
          vel. Asperiores exercitationem dignissimos voluptatibus,
          necessitatibus vero placeat temporibus. Nulla, dolor natus impedit
          odit ipsam sint reprehenderit illum maxime. Culpa, beatae, ratione quo
          voluptatum nesciunt vero sed aliquam quisquam soluta recusandae ab non
          dicta nulla laboriosam illo! Laudantium ea libero molestiae atque, nam
          expedita! Ut incidunt in atque sapiente facilis velit reprehenderit,
          recusandae accusamus dolorum aut asperiores quod beatae maxime.
          Dolore, iste autem?
        </p>
      </div>
    </div>
  );
};

export default DescriptionBox;
